export const isLastActionValid = (missionStop: MissionStop | null): boolean => {
  if (!missionStop) {
    return false;
  }

  if (
    !missionStop.missionStopVdaActions ||
    missionStop.missionStopVdaActions.length === 0
  ) {
    return true;
  }

  const lastAction =
    missionStop.missionStopVdaActions[
      missionStop.missionStopVdaActions.length - 1
    ];

  return Boolean(
    lastAction.actionParameters &&
      lastAction.actionParameters.length > 0 &&
      lastAction.actionParameters[0].triggerType &&
      lastAction.actionParameters[0].triggerType.trim() !== ""
  );
};

export const isStationValid = (missionStop: MissionStop | null): boolean => {
  return Boolean(missionStop?.stopPk && missionStop.stopPk.trim() !== "");
};

export const arePreviousStepsValid = (
  missionStops: MissionStop[],
  currentIndex: number
): boolean => {
  if (missionStops.length === 0) {
    return true;
  }

  for (let i = 0; i <= currentIndex && i < missionStops.length; i++) {
    const stop = missionStops[i];

    if (!isStationValid(stop)) {
      return false;
    }

    if (!isLastActionValid(stop)) {
      return false;
    }
  }
  return true;
};

export const isLastStepValidForNewStep = (
  missionStops: MissionStop[]
): boolean => {
  if (missionStops.length === 0) {
    return true;
  }

  const lastStep = missionStops[missionStops.length - 1];

  if (!isStationValid(lastStep)) {
    return false;
  }

  if (!isLastActionValid(lastStep)) {
    return false;
  }

  return true;
};

export const getValidationErrorForNewStep = (
  missionStops: MissionStop[]
): string | null => {
  if (missionStops.length === 0) {
    return null;
  }

  const lastStep = missionStops[missionStops.length - 1];

  if (!isStationValid(lastStep)) {
    return "Please select a station for the current step before adding a new one";
  }

  if (!isLastActionValid(lastStep)) {
    return "Please select a trigger type for all actions in the current step before adding a new one";
  }

  return null;
};

export const isAddActionButtonDisabled = (
  missionStops: MissionStop[],
  availableActions: any[],
  countTotalTriggerTypesForStop: (stop: MissionStop) => number,
  CONFIRMATION_TYPES: any
): boolean => {
  if (missionStops.length === 0 || availableActions.length === 0) {
    return true;
  }

  if (!missionStops.some((stop) => stop.stopPk)) {
    return true;
  }

  if (missionStops.length > 0) {
    const lastStep = missionStops[missionStops.length - 1];
    const totalTriggerTypesCount = countTotalTriggerTypesForStop(lastStep);

    return (
      totalTriggerTypesCount >= 3 ||
      lastStep?.confirmationType ===
        CONFIRMATION_TYPES.CLOUD_HMI_RELEASE_CONFIRMATION ||
      !isLastActionValid(lastStep)
    );
  }

  return false;
};

export const getAddActionButtonTitle = (
  missionStops: MissionStop[],
  availableActions: any[],
  countTotalTriggerTypesForStop: (stop: MissionStop) => number,
  CONFIRMATION_TYPES: any
): string => {
  if (missionStops.length === 0) {
    return "Add a station first";
  }

  if (availableActions.length === 0) {
    return "Loading actions...";
  }

  if (missionStops.length > 0) {
    const lastStep = missionStops[missionStops.length - 1];
    const totalTriggerTypesCount = countTotalTriggerTypesForStop(lastStep);

    if (totalTriggerTypesCount >= 3) {
      return "Maximum of 3 trigger types allowed per stop";
    }

    if (
      lastStep?.confirmationType ===
      CONFIRMATION_TYPES.CLOUD_HMI_RELEASE_CONFIRMATION
    ) {
      return "Cannot add actions when Double confirmation is selected";
    }

    if (!isLastActionValid(lastStep)) {
      return "Select a trigger type for the previous action first";
    }

    if (!missionStops.some((stop) => stop.stopPk)) {
      return "Select a station for the step first";
    }
  }

  return "Add action";
};
